
import { useUserService } from "../../service/user";


const useDeleteUser = () => {
    const {deleteUser} = useUserService()
  const deleteUserHooks = async (publicId: string) => {
     return await deleteUser(publicId)
  };
  return {
    deleteUserHooks,
  };
};

export default useDeleteUser;
